import { colorGreen, fontWeightStrong } from '@atlas-frontend/design-tokens';
import styled from 'styled-components';

export const GreenString = styled.span`
  font-weight: ${fontWeightStrong};
  color: ${colorGreen[6]};
`;
